import { PUBLIC_INSTALL_PATH } from '../lib/publicInstall';

export function Install(): JSX.Element {
  return (
    <main className="install-page">
      <section className="install-page__card" aria-labelledby="install-title">
        <div className="install-page__mark" aria-hidden="true">
          <img src="/branding/cr-icon-master.png" alt="" />
        </div>
        <p className="install-page__eyebrow">Conscious Ritual</p>
        <h1 id="install-title">A more conscious way to go in depth with your daily rituals</h1>
        <p className="install-page__description">
          Catalogue your stash, curate your own personal blends, track your consumption, and create Rituals to document your experiences!
        </p>
        <a href="/" className="btn btn-primary install-page__open">
          Start your Journey
        </a>

        <div className="install-page__instructions" aria-labelledby="install-instructions-title">
          <h2 id="install-instructions-title">Install on your phone</h2>
          <div className="install-page__instruction">
            <h3>Android · Chrome</h3>
            <p>Open the menu, choose <strong>Install app</strong> (or <strong>Add to Home screen</strong>), then confirm.</p>
          </div>
          <div className="install-page__instruction">
            <h3>iPhone · Safari</h3>
            <p>Tap <strong>Share</strong>, choose <strong>Add to Home Screen</strong>, then tap <strong>Add</strong>.</p>
          </div>
        </div>

        <p className="install-page__note">
          Your profile and personal catalogue stay on this device.
        </p>
        <span className="sr-only">Permanent install path: {PUBLIC_INSTALL_PATH}</span>
      </section>
    </main>
  );
}
